import { createStitches } from '@stitches/react';
import colorTokens from './transformColors';

const stitches = createStitches({
  theme: {
    colors: colorTokens,
  },
  media: {
    bp1: '(min-width: 480px)',
  },
  utils: {
    marginX: (value: any) => ({ marginLeft: value, marginRight: value }),
  },
});

export const { styled, css, globalCss, keyframes, getCssText, theme, createTheme, config } = stitches;
